// import { BehaviorSubject } from "rxjs";
import { cr, URLS } from "fire-wind-water";
import { GetUrl } from "./getUrl";

const getUrl = new GetUrl();

class Lint {
  static modules: { [label: string]: string | any }[] = [];
  isJump: boolean;

  constructor() {
    this.isJump = true;
  }

  async init(data) {
    // const $s = new BehaviorSubject<any>({});
    //  去哪里跳转
    console.log("link参数 ", data);
    const webinarInfo = data.webinarInfo;
    const userInfo = data.userInfo;
    const returnUrl = window.location.href.replace("/meetingInfo", "/meeting");
    //是否需要跳转
    console.log("是否需要跳转 ", webinarInfo.needJump);
    if (
      !webinarInfo.isClosed &&
      !webinarInfo.unLimit &&
      webinarInfo.needLogin &&
      !userInfo.isLogin &&
      !webinarInfo.isClosed &&
      !webinarInfo.unLimit &&
      webinarInfo.needRegistration &&
      !userInfo.isRegistration
    ) {
      await getUrl.goToLogin(webinarInfo, userInfo);
      await getUrl.goToSignUp(webinarInfo);
      //需要登录未登录 并且 需要注册 未注册
      if (webinarInfo.needJump) {
        this.skMeetingLinkStart();
        //需不需要弹窗 （需要登录未登录 并且 需要注册 未注册）
        (window as any).$sk.tips.show("很抱歉，登录成功才能进入本场会议。");
        // 真正的 跳转
        //使用 goto 跳转
        (window as any).$sk.goto(
          webinarInfo.loginUrl +
            "sourceKey=" +
            URLS.getURL("sourceKey") +
            "&backUrl=" +
            encodeURIComponent(webinarInfo.goToSignUpUrl)
        );
      } else {
        this.isJump = true;
      }
    } else if (
      !webinarInfo.isClosed &&
      !webinarInfo.unLimit &&
      webinarInfo.needLogin &&
      !userInfo.isLogin
    ) {
      //需要登录 未登录
      await getUrl.goToLogin(webinarInfo, userInfo);
      if (webinarInfo.needJump) {
        this.skMeetingLinkStart();
        //需不需要弹窗（需要登录 未登录）
        (window as any).$sk.tips.show("很抱歉，登录成功才能进入本场会议。");
        //使用 goto 跳转
        (window as any).$sk.goto(
          webinarInfo.loginUrl +
            "sourceKey=" +
            URLS.getURL("sourceKey") +
            "&backUrl=" +
            encodeURIComponent(returnUrl)
        );
        // 真正的 跳转
      } else {
        this.isJump = true;
      }
    } else if (
      !webinarInfo.isClosed &&
      !webinarInfo.unLimit &&
      webinarInfo.needRegistration &&
      !userInfo.isRegistration
    ) {
      //需要注册 未注册
      await getUrl.goToSignUp(webinarInfo);
      if (webinarInfo.needJump) {
        this.skMeetingLinkStart();
        //需不需要弹窗（需要注册 未注册）
        (window as any).$sk.tips.show("很抱歉，报名成功才能进入本场会议。");
        //使用 goto 跳转
        (window as any).$sk.goto(webinarInfo.goToSignUpUrl);
        // window.location.href = webinarInfo.goToSignUpUrl;
        // 真正的 跳转
      } else {
        this.isJump = true;
      }
    }
    const returnData = {
      isJump: this.isJump,
    };
    return await returnData;
  }

  module(o) {
    const key = `sk_temp_webinar_link_${new Date().getTime()}`;
    Lint.modules.push({
      key,
      model: o,
    });
    return {
      unsubscribe() {
        Lint.modules = Lint.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  // 根据会议状态判断需要跳转时，跳转前触发
  skMeetingLinkStart() {
    cr.each(Lint.modules, (d) => {
      if (d.model.skMeetingLinkStart) {
        d.model.skMeetingLinkStart();
      }
    });
    // window.location.href = 'www.baidu.com';
  }
}
export { Lint };
